
import { PACoordinates } from "./coordinates";
import { TravelTechnicianDate as TravelTechnicianDateHash } from "src/app/_models/planning-assistant.interface";
import { PATechnicianDate } from "./technician-date";
import { PALocation } from "./location";
import { PADataControl } from "../singletons/pa-data-control";
import { PATimeControl } from "../singletons/pa-time-control";
import { FireUpdateOnChange } from "./util-classes/fire-update-on-change";

export class TravelTechnicianDate extends FireUpdateOnChange<void>{

  executeBeforeChange(): void {
  }

  private _dbID?: number
  public location?: PALocation
  private _lastSavedCoordinates: PACoordinates

  constructor(
    readonly technicianID: number,
    readonly timestamp: number,
    config?: { dbID?: number, coordinates?: PACoordinates }
  ) {
    super()
    if (config?.dbID) {
      this._dbID = config?.dbID
      this._lastSavedCoordinates = config?.coordinates
    }
    this.initLocation(config?.coordinates)
  }

  get coordinates() {
    return this.location?.coordinates
  }

  set coordinates(coordinates: PACoordinates) {
    if (!this.location) {
      this.initLocation(coordinates)
    } else {
      this.setLocationCoordinates(coordinates)
    }
  }

  initLocation(coordinates: PACoordinates): void {
    if (!this.location && coordinates) {
      this.setLocationCoordinates(coordinates)
    }
  }

  setLocationCoordinates(coordinates: PACoordinates): void {
    this.location = new PALocation(coordinates, PADataControl.Instance.distanceCalculator, PADataControl.Instance.generateNextLocationId(), '', '', '')
  }

  isActive(): boolean {
    return !!this._dbID
  }

  async updateInDB(): Promise<TravelTechnicianDateHash> {
    if (this.isActive()) {
      let travel_technician_date_data = {
        location_name: this.coordinates?.name || null,
        location_address_latitude: this.coordinates?.latitude || null,
        location_address_longitude: this.coordinates?.longitude || null
      }

      return new Promise((resolve) => {
        PATechnicianDate.travelTechnicianDateService.updateTravelTechnicianDate(this._dbID, {travel_technician_date: travel_technician_date_data}).subscribe(
          async (data) => {
            let map = PATechnicianDate.travelTechnicianDates.get(this.timestamp) as Map<number, TravelTechnicianDate>
            map.set(this.technicianID, this)
            resolve(data)
          },
          (err) => {
            console.error(err)
          },
        )
      })
    }
  }

  async createInDB(): Promise<TravelTechnicianDateHash> {
    if (!this.isActive()) {
      let travel_technician_date_data: {
        user_id: number,
        date: string,
        location_name?: string,
        location_address_latitude?: number,
        location_address_longitude?: number
      }
      if (this.coordinates) {
        travel_technician_date_data = {
          user_id: this.technicianID,
          date: PATimeControl.Instance.formatDate(new Date(this.timestamp)),
          location_name: this.coordinates?.name,
          location_address_latitude: this.coordinates?.latitude,
          location_address_longitude: this.coordinates?.longitude
        }
      } else {
        travel_technician_date_data = {
          user_id: this.technicianID,
          date: PATimeControl.Instance.formatDate(new Date(this.timestamp))
        }
      }

      return new Promise((resolve) => {
        PATechnicianDate.travelTechnicianDateService.createTravelTechnicianDate(travel_technician_date_data).subscribe(
          async (data) => {
            this._dbID = data.id
            if (data.location_address_latitude && data.location_address_longitude) {
              this._lastSavedCoordinates = new PACoordinates(data.location_address_latitude, data.location_address_longitude, data.location_name)
            }
            resolve(data)
          },
          (err) => {
            console.error(err)
          },
        )
      })
    }
  }

  async deleteInDb(): Promise<boolean> {
    if (this.isActive()) {
      return new Promise((resolve) => {
          PATechnicianDate.travelTechnicianDateService.deleteTravelTechnicianDate(this._dbID).subscribe(
            async _ => {
              this._dbID = null
              this.coordinates = null
              resolve(true)
            },
            (err) => {
              console.error(err)
              resolve(false)
            },
          )
        }
      )
    }
  }

  hasChanged(): void {
    this.fireUpdate()
  }

}
